import React from 'react'
import PropTypes from 'prop-types'
import styles from './FileGalleryPage.scss'
import FileGallery from '../../components/FileGallery'
import ConfirmButton from '../../components/ConfirmButton'
import Search from '../../components/Search'
import Upload from '../../components/Upload'
import { Button } from 'reactstrap'
import { FaPlus } from 'react-icons/lib/fa'

const getAcceptValue = type => {
  let acceptValue = [
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.pdf',
    '.xls',
    '.xlsx',
    '.csv',
    '.txt',
    '.zip',
    '.html',
    'image/*'
  ].join(', ')
  if (type === 'image') {
    acceptValue = 'image/*'
  } else if (type === 'not-image') {
    acceptValue = [
      '.doc',
      '.docx',
      '.ppt',
      '.pptx',
      '.pdf',
      '.xls',
      '.xlsx',
      '.csv',
      '.txt',
      '.zip',
      '.html'
    ].join(', ')
  }
  return acceptValue
}

class FileGalleryPage extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      location: null,
      tempFile: {},
      file: {},
      isReplacing: false,
      isLoadingPreview: false,
      errorLoadingFile: false,
      errorLoadingPreview: false,
      isUploading: false,
      isImage: false,
      replaceModalIsOpen: false,
      progress: 0,
      search: '',
      searchValue: '',
      selected: []
    }
  }

  componentWillReceiveProps (newProps) {
    const newFilePage = newProps.filters && this.props.filters && newProps.filters.type !== this.props.filters.type
    const newRefresh = newProps.refreshList !== this.props.refreshList
    const newURL = newProps.match && this.props.match && newProps.match.url !== this.props.match.url

    if (newFilePage) {
      this.setState({
        search: '',
        searchValue: '',
        selected: []
      })
    }

    if (newRefresh || newURL) {
      this.setState({
        selected: []
      })
    }
  }

  onStart = () => {
    this.setState({
      isUploading: true,
      progress: 0
    })
  }

  onFinish = file => {
    this.props.history.push(`/files/${file.id}/replace`)
  }

  onError = error => {
    console.info('Error while uploading:', error)
    throw new Error(error.message || JSON.stringify(error, null, 2))
  }

  upload = e => {
    this.input.click()
  }

  onSearchChange = value => {
    const path = this.props.match.path
    this.props.history.push(path.replace(':paginationPage', 1))
    this.setState({ searchValue: value })
  }

  onRowSelect = (e, row) => {
    const isChecked = e.target.checked

    if (isChecked) {
      this.setState(prevState => ({
        selected: [...prevState.selected, row]
      }))
    } else {
      const list = this.state.selected.filter(item => item.id !== row.id)
      this.setState({
        selected: list
      })
    }
  }

  onClearRowSelect = () => {
    this.setState({ selected: [] })
  }

  onDelete = async () => {
    if (this.state.selected.length === 1) this.props.onDeleteFile(this.state.selected[0])
    if (this.state.selected.length > 1) this.props.onDeleteFiles(this.state.selected)
  }

  render () {
    const props = this.props
    const hasSelections = this.state.selected && this.state.selected.length > 0
    const deleteMsg = <div>
        Are you sure you want to delete these file(s)?
        <div>
          {this.state.selected.map((item, i) => <div key={`select-${i}`}>
            {item.name}
          </div>)
          }
        </div>
    </div>

    return <div className={styles.FileGalleryPage}>
      <Upload
        getRef={input => { this.input = input }}
        accept={getAcceptValue(props.filters && props.filters.type)}
        onFinish={this.onFinish}
        onStart={this.onStart}
        onError={this.onError}
        hide
      />
      <div className={styles.toolbar}>
        <div>
          <Button className='mb-2' color='primary' onClick={this.upload}><FaPlus /> Upload</Button>
          {hasSelections && <ConfirmButton className='mb-2 ml-2' title='Delete File(s)' onConfirm={this.onDelete}
            message={deleteMsg}
            color='danger'>Delete</ConfirmButton>}
        </div>
        <Search value={this.state.searchValue} onSearchChange={this.onSearchChange} />
      </div>
      <FileGallery {...this.props} search={this.state.searchValue} hideSelect rowsSelected={this.state.selected} onRowSelect={this.onRowSelect} onClearRowSelect={this.onClearRowSelect} />
    </div>
  }
}

FileGalleryPage.propTypes = {
  history: PropTypes.object,
  filters: PropTypes.object,
  match: PropTypes.object,
  onDeleteFile: PropTypes.func,
  onDeleteFiles: PropTypes.func,
  refreshList: PropTypes.string
}

export default FileGalleryPage



// WEBPACK FOOTER //
// ./src/pages/FileGalleryPage/FileGalleryPage.js